var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValence2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86,110.7c7.8,0,15.1,2.5,21.3,7.2c1,0.8,1.2,2.3,0.4,3.4c-0.8,1-2.3,1.2-3.4,0.4c-5.3-4.1-11.7-6.2-18.4-6.2c0,0,0,0,0,0 c-6.7,0-13.1,2.2-18.4,6.2c-1,0.8-2.5,0.6-3.4-0.4c-0.8-1-0.6-2.5,0.4-3.4C70.9,113.1,78.2,110.7,86,110.7L86,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,146.5c-37.8,0-68.5-30.7-68.5-68.5C9.5,40.2,40.2,9.5,78,9.5c37.8,0,68.5,30.7,68.5,68.5 C146.5,115.8,115.8,146.5,78,146.5z M78,14.3c-35.1,0-63.7,28.6-63.7,63.7s28.6,63.7,63.7,63.7s63.7-28.6,63.7-63.7 S113.1,14.3,78,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1,64.5c0.7-1.1,1.9-1.3,2.8-0.6c2.5,2.2,6.1,2.9,11,1.9c1.1-0.2,2.1,0.7,2.2,2c0.1,1.3-0.6,2.6-1.7,2.8 c-5.8,1.2-10.5,0.3-13.9-2.7C97.5,67.1,97.4,65.6,98.1,64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,65c0.6,1.1,0.4,2.6-0.5,3.3c-3.5,2.8-8.2,3.4-13.9,1.9c-1.1-0.3-1.8-1.6-1.6-2.9c0.2-1.3,1.2-2.1,2.3-1.8 c4.8,1.3,8.4,0.8,11-1.2C68.6,63.5,69.8,63.9,70.5,65z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValence2);
export default __webpack_public_path__ + "static/media/Valence2.e44d49b6a5bba6a16eca6a3aadd203bf.svg";
export { ForwardRef as ReactComponent };